import * as React from 'react';
import Helmet from 'react-helmet';
import StaticBanner from '../../components/StaticBanner/index';
import { Config } from '../../config/index';
import ContactBanner from '../../assets/images/contact/contact-banner.jpg';

export default function ContactRender(props, { error }) {
  const { submissionError, submissionSuccess } = props;
  const form = this.state.form;

  return (
    <React.Fragment>
      <Helmet>
        <title>Contact</title>
        <link rel="canonical" href={`${Config.FRONT_END_URL}/contact`} />
        <meta name="description" content={'Contact'} />
      </Helmet>
      <div className="page page--contact">
        <StaticBanner
          title={'Contact'}
          bannerImg={{
            fit: 'cover',
            src: ContactBanner
          }}
        />

        <div className="container container-page-contact">
          <p className="form-heading">
            <strong>For any inquiries, please email us at info@tabacalerausa.com</strong>
          </p>

          {/*<form*/}
            {/*action=""*/}
            {/*className="contact-form"*/}
            {/*onSubmit={this.submit}>*/}
            {/*<label htmlFor="first_name">*/}
              {/*<p>First Name</p>*/}
              {/*<input*/}
                {/*type="text"*/}
                {/*name="first_name"*/}
                {/*required*/}
                {/*value={form.first_name}*/}
                {/*onChange={this.change}*/}
              {/*/>*/}
            {/*</label>*/}
            {/*<label htmlFor="last_name">*/}
              {/*<p>Last Name</p>*/}
              {/*<input*/}
                {/*type="text"*/}
                {/*name="last_name"*/}
                {/*required*/}
                {/*value={form.last_name}*/}
                {/*onChange={this.change}*/}
              {/*/>*/}
            {/*</label>*/}
            {/*<label htmlFor="email">*/}
              {/*<p>Email</p>*/}
              {/*<input*/}
                {/*type="email"*/}
                {/*name="email"*/}
                {/*required*/}
                {/*value={form.email}*/}
                {/*onChange={this.change}*/}
              {/*/>*/}
            {/*</label>*/}
            {/*<label htmlFor="question">*/}
              {/*<p>Question</p>*/}
              {/*<input*/}
                {/*type="text"*/}
                {/*name="question"*/}
                {/*required*/}
                {/*value={form.question}*/}
                {/*onChange={this.change}*/}
              {/*/>*/}
            {/*</label>*/}
            {/*<button className="themed-btn themed-btn--lg theme-red" type="submit">*/}
              {/*Submit*/}
            {/*</button>*/}
          {/*</form>*/}

          {/*{(error || submissionError) && (*/}
            {/*<p className="error">*/}
              {/*{error}*/}
            {/*</p>*/}
          {/*)}*/}

          {/*{submissionSuccess && (*/}
            {/*<p className="success">*/}
              {/*Thank you for your message! We will get back to you shortly.*/}
            {/*</p>*/}
            {/*)}*/}
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Contact/render.tsx